module.exports = __webpack_public_path__ + "img/category_finishing.1ffe28eb.jpg";